import React from "react";
import s from "./ViewDetails.module.scss";
import { useLocation, useParams } from "react-router-dom";
import useSWR from "swr";
import { swrFetcher } from "../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import { UserDetailsType } from "../../../../../../../libs/Utils/Types/APIManagement";
import dayjs from "dayjs";
import { Skeleton } from "antd";
import TableWrapper from "./local component/TableWrapper";
type NavigationStateType = {
  fullName: string;
};
function ViewDetails() {
  const location = useLocation();
  const token = UseAuthToken();
  const { fullName = "" } = (location.state as NavigationStateType) || {};

  const { id } = useParams();
  const { data, isLoading } = useSWR<{ data: UserDetailsType }, any, any>(
    token ? [`api/admin/api-keys/users/${id}/stats`, token] : null,
    swrFetcher,
  );
  return (
    <div className={s.wrapper}>
      <h3 className={s.title}>{fullName}</h3>

      {isLoading ? (
        <div className={s.loadingWrapper}>
          <div className={s.item}>
            <Skeleton
              active
              title={false}
              paragraph={{ rows: 1, width: "100%" }}
            />
            <Skeleton
              active
              title={false}
              paragraph={{ rows: 1, width: "100%" }}
            />
          </div>
          <div className={s.item}>
            <Skeleton
              active
              title={false}
              paragraph={{ rows: 1, width: "100%" }}
            />
            <Skeleton
              active
              title={false}
              paragraph={{ rows: 1, width: "100%" }}
            />
          </div>
          <div className={s.item}>
            <Skeleton
              active
              title={false}
              paragraph={{ rows: 1, width: "100%" }}
            />
            <Skeleton
              active
              title={false}
              paragraph={{ rows: 1, width: "100%" }}
            />
          </div>
        </div>
      ) : (
        <div className={s.statWrapper}>
          <div className={s.item}>
            <h6 className={s.label}>API Key Created</h6>
            <p className={s.value}>
              {data?.data.totalApiKeyCount.toLocaleString() || 0}/200
            </p>
          </div>
          <div className={s.item}>
            <h6 className={s.label}>Total API Requests</h6>
            <p className={s.value}>
              {data?.data.totalRequests.toLocaleString() || 0}/5,000,000
            </p>
          </div>
          <div className={s.item}>
            <h6 className={s.label}>Last Activity</h6>
            <p className={s.value}>
              {dayjs.utc(data?.data.lastActivityAt)
                .local()
                .format("YYYY-MM-DD hh:33:ss")}
            </p>
          </div>
        </div>
      )}
      <TableWrapper id={id!} />
    </div>
  );
}

export default ViewDetails;
